/**
 * 導覽列頂層點亮邏輯模組 (Navigation Highlight Module) - 自動偵測路徑版
 * @param {string[]} selectors - 包含 CSS 選擇器的字串陣列
 */
function initHighlight(selectors = []) {
  // 1. 自動偵測 BasePath (不再依賴外部傳入變數)
  // 直接尋找網頁中的首頁連結，提取最準確的專案基底路徑
  let basePath = '/';
  const homeLink = document.querySelector('a[data-key="home"], a[data-lk="home"]');

  if (homeLink) {
    // 利用 URL API 解析絕對路徑 (localhost 會拿到 '/leyu/'，正式機拿到 '/')
    const homeUrl = new URL(homeLink.href, window.location.origin);
    basePath = homeUrl.pathname;
  }

  // 標準化：去除結尾的斜線，確保後續字串比對與剃除不會出錯
  if (basePath.endsWith('/')) {
    basePath = basePath.slice(0, -1);
  }

  // 2. 擷取當前網址的頂層模組名稱
  const currentPath = window.location.pathname; // 例: /leyu/classicProjects
  let cleanPath = currentPath;

  // 如果當前路徑包含 basePath，就將其剃除 (例如把 /leyu/classicProjects 變成 /classicProjects)
  if (basePath !== '' && currentPath.toLowerCase().startsWith(basePath.toLowerCase())) {
    cleanPath = currentPath.substring(basePath.length);
  }

  const segments = cleanPath.split('/').filter(Boolean);
  const currentTopSegment = segments.length > 0 ? segments[0].toLowerCase() : 'home';

  // [偵錯訊息] 確認路徑解析狀況
  // console.log("[Nav Highlight] 自動偵測的基準路徑 (BasePath):", basePath || "/");
  // console.log("[Nav Highlight] 剃除基底後的乾淨路徑:", cleanPath);
  // console.log("[Nav Highlight] 當前判定頂層模組:", currentTopSegment);
  // =====

  // 3. 掃描與點亮邏輯
  selectors.forEach(selector => {
    const links = document.querySelectorAll(selector);

    links.forEach(link => {
      let key = link.getAttribute('data-key') || link.getAttribute('data-lk');

      // 容錯機制
      if (!key) {
        if (link.hasAttribute(currentTopSegment)) {
          key = currentTopSegment;
        } else {
          const href = link.getAttribute('href');
          if (href && !href.includes('javascript:void(0)')) {
            try {
              const linkUrl = new URL(href, window.location.origin);
              let linkClean = linkUrl.pathname;
              if (basePath !== '' && linkClean.toLowerCase().startsWith(basePath.toLowerCase())) {
                linkClean = linkClean.substring(basePath.length);
              }
              const linkSegments = linkClean.split('/').filter(Boolean);
              key = linkSegments.length > 0 ? linkSegments[0].toLowerCase() : 'home';
            } catch (e) { }
          }
        }
      }

      if (key) {
        key = key.toLowerCase();
      }

      // 4. 點亮判斷
      if (key === currentTopSegment) {
        // 直接對 <a> 標籤進行操作
        link.classList.add('active');
        // console.log("[Nav Highlight] 成功點亮 <a> 標籤:", link);

        // 雙重保險：透過 JavaScript 強制覆蓋內部 <div> 樣式
        // 避免 Tailwind CSS 結構變更時導致視覺未更新
        const innerTextDiv = link.querySelector('div');
        if (innerTextDiv) innerTextDiv.classList.add('!text-black');

        const decoDiv = link.querySelector('.deco');
        if (decoDiv) decoDiv.classList.add('!opacity-100');
      }
    });
  });
}

export { initHighlight };